import React, {useState} from 'react';
import {Box, Tab, Tabs} from "@mui/material";
import BotConditionISP from "./BotConditionISP";
import BotConditionUserAgent from "./BotConditionUserAgent";
import BotConditionIP from "./BotConditionIP";
import BotConditionReferrer from "./BotConditionReferrer";
import BotConditionReferrerDomain from "./BotConditionReferrerDomain";
import BotConditionDeviceType from "./BotConditionDeviceType";
import BotConditionDeviceVendor from "./BotConditionDeviceVendor";
import BotConditionOS from "./BotConditionOS";
import BotConditionBrowser from "./BotConditionBrowser";
import BotConditionBrowserLanguage from "./BotConditionBrowserLanguage";
import BotConditionGeo from "./BotConditionGeo";
import BotConditionCustom from "./BotConditionCustom";

import {getSettingsColors} from "../SettingsDesign";

function TabPanel(props) {
    const {children, value, index, ...other} = props;

    return (
        <Box
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-prevent-tabpanel-${index}`}
            aria-labelledby={`scrollable-prevent-tab-${index}`}
            sx={{pt: 2, pb: 0, minWidth: 0}}
            {...other}
        >
            {value === index && (
                <Box sx={{display: 'grid', gap: 1.5, minWidth: 0}}>{children}</Box>
            )}
        </Box>
    );
}

function a11yProps(index) {
    return {
        id: `scrollable-prevent-tab-${index}`,
        'aria-controls': `scrollable-prevent-tabpanel-${index}`,
    };
}

function BotConditions({control, register, errors, setValue, getValues}) {
    const [tabValue, setTabValue] = useState(0);

    const handleChangeSelectedTab = (event, newValue) => {
        setTabValue(newValue);
    };

    const tabStyles = {
        minWidth: 88,
        minHeight: 38,
        flex: {sm: 1},
        px: 1.5,
        py: 1,
        borderRadius: '7px',
        color: theme => getSettingsColors(theme).muted,
        '&.Mui-selected': {bgcolor: theme => getSettingsColors(theme).input, color: 'primary.main', fontWeight: 600},
        fontSize: 13,
        textTransform: 'none'
    };

    return (
        <Box sx={{flexGrow: 1, minWidth: 0, width: '100%', border: 0,
            bgcolor: 'transparent'}}>
            <Box>
                <Tabs
                    value={tabValue}
                    onChange={handleChangeSelectedTab}
                    variant="scrollable"
                    scrollButtons={false}
                    aria-label="conditions-tabs"
                    slotProps={{indicator: {sx: {display: 'none'}}}}
                    textColor="primary"
                    sx={{
                        backgroundColor: theme => getSettingsColors(theme).inset,
                        p: 0.5,
                        minHeight: 42,
                        borderRadius: '10px',
                        '& .MuiTabs-list': {gap: 0.5},
                        width: "100%",
                        mt: 0
                    }}
                >
                    <Tab sx={tabStyles} label="Connection" aria-label="Connection" {...a11yProps(0)} />
                    <Tab sx={tabStyles} label="Device" aria-label="Device" {...a11yProps(1)} />
                    <Tab sx={tabStyles} label="Referrer" aria-label="Referrer" {...a11yProps(2)} />
                    <Tab sx={tabStyles} label="Geo" aria-label="Geo" {...a11yProps(3)} />
                    <Tab sx={tabStyles} label="Custom" aria-label="Custom" {...a11yProps(4)} />
                </Tabs>
            </Box>

            <TabPanel value={tabValue} index={0}>
                <BotConditionISP
                    control={control} register={register} errors={errors} setValue={setValue}
                    getValues={getValues}/>
                <BotConditionIP
                    control={control} register={register} errors={errors} setValue={setValue}
                    getValues={getValues}
                />
            </TabPanel>

            <TabPanel value={tabValue} index={1}>
                <BotConditionDeviceType
                    control={control} register={register} errors={errors} setValue={setValue}
                    getValues={getValues}
                />
                <BotConditionDeviceVendor
                    control={control} register={register} errors={errors} setValue={setValue}
                    getValues={getValues}
                />
                <BotConditionOS
                    control={control} register={register} errors={errors} setValue={setValue}
                    getValues={getValues}
                />
                <BotConditionBrowser
                    control={control} register={register} errors={errors} setValue={setValue}
                    getValues={getValues}
                />
                <BotConditionBrowserLanguage
                    control={control} register={register} errors={errors} setValue={setValue}
                    getValues={getValues}
                />
                <BotConditionUserAgent
                    control={control} register={register} errors={errors} setValue={setValue}
                    getValues={getValues}
                />
            </TabPanel>

            <TabPanel value={tabValue} index={2}>
                <BotConditionReferrer
                    control={control} register={register} errors={errors} setValue={setValue}
                    getValues={getValues}
                />
                <BotConditionReferrerDomain
                    control={control} register={register} errors={errors} setValue={setValue}
                    getValues={getValues}
                />
            </TabPanel>

            <TabPanel value={tabValue} index={3}>
                <BotConditionGeo
                    control={control} register={register} errors={errors} setValue={setValue}
                    getValues={getValues}
                />
            </TabPanel>

            <TabPanel value={tabValue} index={4}>
                <BotConditionCustom
                    control={control} register={register} errors={errors} setValue={setValue}
                    getValues={getValues}
                />
            </TabPanel>
        </Box>
    );
}

export default BotConditions;
